<template>
  <div id="tabs" :class="['golf-outer', dataReady ? 'loaded' : '']" class="for-max-width-measure">
    <div class="home-page game-outer">
      <div v-if="!showAdminClubPopup" class="tabs">
        <a v-on:click="[activetab='1', pageQuery=1]" v-bind:class="[ activetab === '1' ? 'active' : '' ]">Medal List</a>
        <a v-on:click="[activetab='2', pageQuery=1]" v-bind:class="[ activetab === '2' ? 'active' : '' ]">User List</a>
        <a v-on:click="[activetab='3', pageQuery=1]" v-bind:class="[ activetab === '3' ? 'active' : '' ]">Golf Protection List</a>
        <a v-on:click="[activetab='4', pageQuery=1]" v-bind:class="[ activetab === '4' ? 'active' : '' ]">Club List</a>
        <a v-on:click="[activetab='5', pageQuery=1]" v-bind:class="[ activetab === '5' ? 'active' : '' ]">Hardest Question Stats</a>
        <a v-on:click="[activetab='6', pageQuery=1]" v-bind:class="[ activetab === '6' ? 'active' : '' ]">Easiest Question Stats</a>
        <a v-on:click="[activetab='7', pageQuery=1]" v-bind:class="[ activetab === '7' ? 'active' : '' ]">Medal subscribed</a>
      </div>
      <div  v-if="!showAdminClubPopup && !['5', '6'].includes(activetab)" class="download-btn">
        <div class="from-date">
          <label> From date&nbsp;</label>
          <datepicker v-model="fromDate" :placeholder="'Click to select date'" class="pointer"></datepicker>
        </div>
        <div class="to-date">
          <label> To date &nbsp;</label>
          <datepicker v-model="toDate" :placeholder="'Click to select date'" class="pointer"></datepicker>
        </div>
        <a class="btn btn-sm btn-success" :href="`/download/report/?from_date=${convertToUnixVal(fromDate)}&to_date=${convertToUnixVal(toDate)}&active_tab=${activetab}`" target="_blank">Download</a>
      </div>
      <div v-if="!showAdminClubPopup" class="content row">
        <div v-if="activetab ==='1' && medalList &&  medalList.data && medalList.data.length > 0" class="col-md-12 tabcontent">
          <table>
            <tr class="list-head">
              <th>Name</th>
              <th>Address</th>
              <th>Post Number</th>
              <th>Requested Date</th>
              <th>Region</th>
              <th>Medal Status</th>
            </tr>
            <tr v-for="(medal,index) in medalList.data" :key="index"
             :class="!medal.user ? 'withoutplay' : ''">
              <td class="withplay">
                <span v-if="medal.name">{{medal.name}}</span>
                <span v-else>-</span>
              </td>
              <td  class="withplay">
                <span v-if="medal.address">{{medal.address}}</span>
                <span v-else>-</span>
              </td>
              <td class="withplay">
                <span v-if="medal.post_number">{{medal.post_number}}</span>
                <span v-else>-</span>
              </td>
              <td class="withplay">
                <span v-if="medal.requested_date">{{medal.requested_date | timestamp}}</span>
                <span v-else>-</span>
              </td>
              <td  class="withplay">
                <span v-if="medal.region">{{medal.region}}</span>
                <span v-else>-</span>
              </td>
              <td  class="withplay">
                <input
                  type="checkbox"
                  name="medal"
                  :value="medal.key"
                  v-model="medalArray[index]['value']"
                  v-if="medalArray && medalArray[index] && medalArray[index]['value']"
                >
              </td>
            </tr>
            <div class="btn-groups">
              <div class="senda-button">
                <button type="button" v-on:click="sendMedal()">Update Medal Status</button>
              </div>
              <div class="senda-button">
                <button type="button" v-on:click="sendAllMedal()">Update All Medal Status</button>
              </div>
            </div>
          </table>
          <pagination
            v-if="medalList && medalList.total_pages && medalList.total_pages > 1"
            :pagination="medalList"
            @paginate="pageQuery = $event"
          ></pagination>
        </div>
        <div v-if="activetab ==='2' && userList && userList.data && userList.data.length > 0"
          class="col-md-12 tabcontent">
          <table>
            <tr class="list-head">
              <th>Name</th>
              <th>Joined At</th>
              <th>Logged In Via</th>
              <th>Facebook Id</th>
              <th>Total Points</th>
              <th>Medal Subscribed</th>
            </tr>
            <tr v-for="(user,index) in userList.data" :key="index">
              <td>
                <span v-if="user.name">{{user.name}}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="user.joined_at">{{user.joined_at | timestamp}}</span>
                <span v-else>-</span>
              </td>
              <td>
                  <span v-if="user.logged_in_by">{{user.logged_in_by}}</span>
                  <span v-else>-</span>
              </td>
              <td>
                <span v-if="user.facebook_id">{{user.facebook_id}}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span>{{ user.best_score }}</span>
              </td>
              <td>
                <span v-if="user.medal_subscribed">
                  Yes
                </span>
                <span v-else>No</span>
              </td>
            </tr>
          </table>
          <pagination
            v-if="userList && userList.total_pages && userList.total_pages > 1"
            :pagination="userList"
            @paginate="pageQuery = $event"
          ></pagination>
        </div>
         <!-- <div v-if="activetab ==='2' && userList && userList.data && userList.data.length > 0"
           class="col-md-12 tabcontent">
          <table>
            <tr class="list-head">
              <th>Name</th>
              <th>Email</th>
              <th>Joined At</th>
            </tr>
            <tr v-for="(user,index) in userList.data" :key="index">
              <td>
                <span v-if="user.name">{{user.name}}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="user.email">{{user.email}}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="user.joined_at">{{user.joined_at | timestamp}}</span>
                <span v-else>-</span>
              </td>
            </tr>
          </table>
          <pagination
            v-if="userList && userList.total_pages && userList.total_pages > 1"
            :pagination="userList"
            @paginate="pageQuery = $event"
          ></pagination>
        </div> -->
        <div v-if="activetab ==='3' && protectionList && protectionList.data && protectionList.data.length > 0" class="col-md-12 tabcontent">
          <table>
            <tr class="list-head">
              <th>Name</th>
            </tr>
            <tr v-for="(item,index) in protectionList.data" :key="index">
              <td>
                <span v-if="item.name">{{item.name}}</span>
                <span v-else>-</span>
              </td>
            </tr>
          </table>
          <pagination
            v-if="protectionList && protectionList.total_pages && protectionList.total_pages > 1"
            :pagination="protectionList"
            @paginate="pageQuery = $event"
          ></pagination>
        </div>
        <div v-if="activetab ==='4'" class="col-md-12 tabcontent">
          <table>
            <tr class="list-head">
                <th>Club Image</th>
                <th>Club Name</th>
                <th>Total Points</th>
                <th>Completed Regluvörður</th>
                <th>Maximum Members</th>
                <th>Percentage</th>
            </tr>
              <tr class="golf-list-row" v-for="(club,index) in clubList" :key="index"
               @click="showPopupClub(club.key)">
                <td>
                  <div class="club-img">
                    <img v-bind:src="club.image_url" alt="club"/>
                  </div>
                </td>
                <td class="club-name-row">{{club.name}}</td>
                <td>{{club.total_points}}</td>
                <td>{{club.total_members}}</td>
                <td>{{club.maximum_members}}</td>
                <td>{{club.percentage}}</td>
              </tr>
          </table>
        </div>
        <div v-if="activetab ==='5'" class="col-md-12 tabcontent">
          <table>
            <tr class="list-head">
              <th>Question</th>
              <th>Level</th>
              <th>Attended</th>
              <th>Answered wrong</th>
              <th>Answered Correct</th>
            </tr>
            <tr class="statistics-data" v-for="item in questionList" :key="item">
              <td class="question-text">{{item.question_info.question}}</td>
              <td>{{item.question_info.level}}</td>
              <td>{{item.attended}}</td>
              <td>{{item.answered_wrong}}</td>
              <td>{{item.answered_correct}}</td>
            </tr>
          </table>
        </div>
        <div v-if="activetab ==='6'" class="col-md-12 tabcontent">
          <table>
            <tr class="list-head">
              <th>Question</th>
              <th>Level</th>
              <th>Attended</th>
              <th>Answered wrong</th>
              <th>Answered Correct</th>
            </tr>
            <tr class="statistics-data" v-for="item in correctQuestionList" :key="item">
              <td class="question-text">{{item.question_info.question}}</td>
              <td>{{item.question_info.level}}</td>
              <td>{{item.attended}}</td>
              <td>{{item.answered_wrong}}</td>
              <td>{{item.answered_correct}}</td>
            </tr>
          </table>
        </div>
        <!-- <div v-if="activetab ==='7' && medalSubscribedLList && medalSubscribedLList.data && medalSubscribedLList.data.length > 0"
          class="col-md-12 tabcontent">
          <table>
            <tr class="list-head">
              <th>Name</th>
              <th>Email</th>
              <th>Joined At</th>
              <th>Logged In Via</th>
              <th>Facebook Id</th>
              <th>Current Level</th>
              <th>Medal Subscribed</th>
            </tr>
            <tr v-for="(user,index) in medalSubscribedLList.data" :key="index">
              <td>
                <span v-if="user.name">{{user.name}}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="user.email">{{user.email}}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="user.joined_at">{{user.joined_at | timestamp}}</span>
                <span v-else>-</span>
              </td>
              <td>
                  <span v-if="user.logged_in_by">{{user.logged_in_by}}</span>
                  <span v-else>-</span>
              </td>
              <td>
                <span v-if="user.facebook_id">{{user.facebook_id}}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="user.current_level && user.current_level.name">
                {{user.current_level.name}}
                </span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="user.medal_subscribed">
                  Yes
                </span>
                <span v-else>No</span>
              </td>
            </tr>
          </table>
          <pagination
            v-if="medalSubscribedLList && medalSubscribedLList.total_pages && medalSubscribedLList.total_pages > 1"
            :pagination="medalSubscribedLList"
            @paginate="pageQuery = $event"
          ></pagination>
        </div> -->
      </div>
      <admin-club-info v-if="showAdminClubPopup" @hidepopup="hidepopup"
      :clubKey="activeKey"></admin-club-info>
    </div>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import API from '@/shared/api'
export default {
  name: 'AdminDashboard',
  components: {
    Datepicker
  },
  data () {
    return {
      activetab: '1',
      clubList: null,
      userList: null,
      subscriptionList: null,
      medalList: null,
      protectionList: null,
      showPagination: true,
      pageQuery: 1,
      sendMedalInfo: null,
      medalArray: [],
      activeKey: null,
      showAdminClubPopup: false,
      dataReady: false,
      questionList: null,
      correctQuestionList: null,
      fromDate: null,
      toDate: null
      // medalSubscribedLList: null
    }
  },
  created () {
    if (this.$route.query.page) {
      this.pageQuery = this.$route.query.page
    }
    var apiUrl = '/clubs/points/'
    this.getListData(apiUrl)
    if (this.$route.name === 'AdminDashboard') {
      this.getMedalList()
      this.getUserData()
      this.getProtectionList()
      this.getQuestionList()
      this.getCorrectQuestionList()
      // this.getMedalSubscribedData()
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.name === 'AdminDashboard') {
        this.getMedalList()
        this.getUserData()
        this.getProtectionList()
      }
    },
    pageQuery () {
      this.refreshData()
    }
  },
  methods: {
    refreshData() {
      this.medalArray = []
      this.$router.replace( {query: { 'page': this.pageQuery } }
      )
    },
    getListData (apiUrl) {
      API.meInstance.get(apiUrl).then((res) => {
        if (res.data) {
          this.clubList = res.data.clubs
           this.dataReady = true
        }
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    getUserData () {
      let queryParams = {
        'page': this.pageQuery
      }
      API.meInstance.get('/admin/users/', { params: queryParams }).then((res) => {
        if (res.data) {
          this.userList = res.data
          this.dataReady = true
        }
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    // getMedalSubscribedData () {
    //   let queryParams = {
    //     'page': this.pageQuery
    //   }
    //   API.meInstance.get('/admin/medal_subscribed/', { params: queryParams }).then((res) => {
    //     if (res.data) {
    //       console.log('res', res)
    //       this.medalSubscribedLList = res.data
    //       this.dataReady = true
    //     }
    //   }).catch((error) => {
    //     console.log('Error loading', error)
    //   })
    // },
    getMedalList () {
      let queryParams = {
        'page': this.pageQuery
      }
      API.meInstance.get('/admin/medal/list/', { params: queryParams }).then((res) => {
        if (res.data) {
          this.medalList = res.data
          this.dataReady = true
          for(let medal in this.medalList.data) {
            let medalObject = {}
            medalObject['key'] = this.medalList.data[medal]['key']
            medalObject['value'] = this.medalList.data[medal]['sent_medal_to_customer']
            this.medalArray.push(medalObject)
          }
        }
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    sendAllMedal () {
      for (var medalKey of this.medalList.data) {
        this.medalArray.push({'key': medalKey.key, 'value': true})
      }
      this.sendMedal()
    },
    sendMedal (keyValue) {
      API.meInstance.post(
        '/medal/action/',
        {"medal_subscribers": this.medalArray}
      ).then((res) => {
        this.sendMedalInfo = res.data.data
        this.dataReady = true
        this.getMedalList()
        if (res) {
          if (res.data.data) {
          const h = this.$createElement
          this.$notify({
            // title: 'Árangur',
            customClass: 'success-msg',
            message: h('i', { style: 'color: #6cc65b' }, res.data.data)
          })
          } else {
          const h = this.$createElement
            this.$notify({
              // title: 'Villa',
              customClass: 'error-msg',
              message: h('i', { style: 'color: #f7653a' }, res.data.error)
            })
          }
        }
      })
    },
    getProtectionList () {
      let queryParams = {
        'page': this.pageQuery
      }
      API.meInstance.get('/admin/golf/protection/list/',{ params: queryParams }).then((res) => {
        if (res.data) {
          this.protectionList = res.data
          this.dataReady = true
        }
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    getQuestionList () {
      API.meInstance.get('/admin/question/statistics/?sort_by=wrong').then((res) => {
        if (res.data) {
          this.questionList = res.data.data
          this.dataReady = true
        }
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    getCorrectQuestionList () {
      API.meInstance.get('/admin/question/statistics/?sort_by=correct').then((res) => {
        if (res.data) {
          this.correctQuestionList = res.data.data
          this.dataReady = true
        }
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    showPopupClub (key) {
      this.showAdminClubPopup = true
      this.activeKey = key
    },
    hidepopup() {
      this.showAdminClubPopup = false
    },
    convertToUnixVal (date) {
      return this.$moment(date).unix()
    }
  }
}
</script>

<style lang="scss">
.vdp-datepicker {
  display: inline-block;
  & > div {
    input {
      margin-right: 25px;
    }
  }
}
.download-btn {
  display: flex;
}
.pointer {
  input {
    cursor: pointer;
    border: 2px solid #519E44;
    border-radius: 3px;
  }
}
</style>
<style lang="scss" scoped>
.club-img {
  width: 100px;
}
.from-date, .to-date {
  position: relative;
  label {
    position: absolute;
    top: -30px;
    display: inline-block;
  }
}
.withoutplay {
  background: #fffad5;
}
.withplay {
  background: initial;
}
.list-head {
  th {
    font-size: 16px;
  }
}
.golf-list-row {
  cursor: pointer;
}
.download-btn {
  text-align: right;
  padding: 55px 25px 0 40px;
}
.club-name-row {
  &:hover {
    text-decoration: underline;
  }
}
.btn-groups {
  position: absolute;
  right: 40px;
  .senda-button {
    display: inline-block;
    margin: 0px 5px;
  }
}
.senda-button {
  button {
    font-size: 14px;
    padding: 6px 25px 6px 25px !important;
  }
}
.tabs {
  padding: 20px 20px 0 20px;
}
.col-md-12 {
  overflow-x: auto;
}
.tabs a{
  cursor: pointer;
  padding: 12px 24px;
  transition: all linear 0.3s;
  color: #181818;
  font-weight: bold;
  &:hover {
    text-decoration: none;
  }
}
.tabs a.active {
  border-bottom: 3px solid #FCBD00;
  color: #181818;
  cursor: default;
}
.tabcontent {
  padding: 0px 40px 40px 40px;
}
table {
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0;
}
td, th {
  text-align: left;
  padding: 8px;
}
td {
  background: #F7F7F3;
  border-top: 1px solid #EAEAE3;
  border-bottom: 1px solid #EAEAE3;
}
.statistics-data {
  font-size: 15px;
}
.question-text {
  width: 50%;
  padding-right: 50px;
}
@media (max-width: 767px) {
  td,.tabs {
    font-size: 12px;
  }
  .list-head {
    th {
      font-size: 12px;
    }
  }
  .tabs a{
    padding: 10px;
  }
  .tabs {
    padding-left: 3px;
  }
  .tabcontent {
    padding: 10px;
  }
}
</style>